"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceReducerFunction = exports.invoiceActions = exports.invoiceState = exports.initialState = void 0;
var immer_reducer_1 = require("immer-reducer");
exports.initialState = {
    data: {
        lastProductInvoice: null,
        productInvoices: [],
        invoices: [],
        invoiceDocuments: null
    },
    lastBill: {
        loading: false,
        success: false,
        errorMessage: null,
        data: null
    },
    billsList: {
        loading: false,
        success: false,
        errorMessage: null,
        data: null
    },
    loading: false,
    loaded: false,
    errorMsg: null,
    downloadErrorMsg: null,
    isDownloadForPreview: false,
    downloadLoading: false,
    downloadForPreviewLoading: false,
    lastProductInvoiceLoading: false,
    lastProductInvoiceError: null,
    productInvoicesLoading: false,
    productInvoicesError: null,
    invoicesLoading: false,
    invoicesError: null,
    errorStatus: null,
    downloadErrorStatusMessage: null
};
var invoiceState = /** @class */ (function (_super) {
    __extends(invoiceState, _super);
    function invoiceState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    invoiceState.prototype.reset = function () {
        this.draftState = exports.initialState;
    };
    invoiceState.prototype.fetchLastInvoice = function (billingAgreementId) {
        this.draftState.lastProductInvoiceLoading = true;
        this.draftState.loaded = false;
        this.draftState.lastProductInvoiceError = null;
        this.draftState.data.lastProductInvoice = null;
    };
    invoiceState.prototype.fetchLastInvoiceSuccess = function (productInvoice) {
        this.draftState.lastProductInvoiceLoading = false;
        this.draftState.loaded = true;
        this.draftState.data.lastProductInvoice = productInvoice;
        this.draftState.lastProductInvoiceError = null;
    };
    invoiceState.prototype.fetchLastInvoiceFailure = function (errorMsg) {
        this.draftState.lastProductInvoiceLoading = false;
        this.draftState.lastProductInvoiceError = errorMsg;
        this.draftState.loaded = false;
        this.draftState.data.lastProductInvoice = null;
    };
    invoiceState.prototype.fetchAllInvoices = function (billingAgreementId) {
        this.draftState.productInvoicesLoading = true;
        this.draftState.loaded = false;
        this.draftState.data.productInvoices = [];
        this.draftState.productInvoicesError = null;
    };
    invoiceState.prototype.fetchAllInvoicesSuccess = function (productInvoices) {
        this.draftState.productInvoicesLoading = false;
        this.draftState.loaded = true;
        this.draftState.data.productInvoices = productInvoices;
        this.draftState.productInvoicesError = null;
    };
    invoiceState.prototype.fetchAllInvoicesFailure = function (errorMsg) {
        this.draftState.productInvoicesLoading = false;
        this.draftState.productInvoicesError = errorMsg;
        this.draftState.loaded = false;
        this.draftState.data.productInvoices = [];
    };
    invoiceState.prototype.getAllInvoices = function (billingAgreementId) {
        this.draftState.invoicesLoading = true;
        this.draftState.loaded = false;
        this.draftState.data.invoices = [];
        this.draftState.invoicesError = null;
    };
    invoiceState.prototype.getAllInvoicesSuccess = function (invoices) {
        this.draftState.invoicesLoading = false;
        this.draftState.loaded = true;
        this.draftState.data.invoices = invoices;
        this.draftState.invoicesError = null;
    };
    invoiceState.prototype.getAllInvoicesFailure = function (errorMsg) {
        this.draftState.invoicesLoading = false;
        this.draftState.invoicesError = errorMsg;
        this.draftState.loaded = false;
        this.draftState.data.invoices = [];
    };
    invoiceState.prototype.downloadInvoiceDocuments = function (downloadDocumentPayload) {
        this.draftState.downloadLoading = true;
        this.draftState.errorStatus = null;
        this.draftState.downloadErrorStatusMessage = null;
        this.draftState.isDownloadForPreview = false;
    };
    invoiceState.prototype.downloadInvoiceDocumentsForPreview = function (downloadDocumentPayload) {
        this.draftState.downloadForPreviewLoading = true;
        this.draftState.errorStatus = null;
        this.draftState.downloadErrorStatusMessage = null;
        this.draftState.isDownloadForPreview = true;
    };
    invoiceState.prototype.downloadInvoiceDocumentsSuccess = function (invoiceDocuments) {
        this.draftState.downloadLoading = false;
        this.draftState.loaded = true;
        this.draftState.downloadErrorMsg = null;
        this.draftState.data.invoiceDocuments = invoiceDocuments;
        this.draftState.isDownloadForPreview = false;
        this.draftState.errorStatus = null;
        this.draftState.downloadErrorStatusMessage = null;
    };
    invoiceState.prototype.downloadInvoiceDocumentsSuccessForPreview = function (invoiceDocuments) {
        this.draftState.downloadForPreviewLoading = false;
        this.draftState.loaded = true;
        this.draftState.downloadErrorMsg = null;
        this.draftState.data.invoiceDocuments = invoiceDocuments;
        this.draftState.isDownloadForPreview = true;
        this.draftState.errorStatus = null;
        this.draftState.downloadErrorStatusMessage = null;
    };
    invoiceState.prototype.downloadInvoiceDocumentsFailure = function (errorMsg, errorStatus, errorLabel) {
        this.draftState.downloadForPreviewLoading = false;
        this.draftState.downloadLoading = false;
        this.draftState.downloadErrorMsg = errorMsg;
        this.draftState.errorStatus = errorStatus;
        this.draftState.downloadErrorStatusMessage = errorLabel;
    };
    invoiceState.prototype.downloadInvoiceDocumentsReset = function () {
        this.draftState.data.invoiceDocuments = null;
        this.draftState.errorStatus = null;
    };
    invoiceState.prototype.fetchLastBill = function (customerAccountId) {
        this.draftState.lastBill.loading = true;
        this.draftState.lastBill.success = false;
        this.draftState.lastBill.errorMessage = null;
        this.draftState.lastBill.data = null;
    };
    invoiceState.prototype.fetchLastBillSuccess = function (data) {
        this.draftState.lastBill.loading = false;
        this.draftState.lastBill.success = true;
        this.draftState.lastBill.errorMessage = null;
        this.draftState.lastBill.data = data;
    };
    invoiceState.prototype.fetchLastBillFailure = function (error) {
        this.draftState.lastBill.loading = false;
        this.draftState.lastBill.success = false;
        this.draftState.lastBill.errorMessage = error;
        this.draftState.lastBill.data = null;
    };
    invoiceState.prototype.fetchBillsList = function (customerAccountId) {
        this.draftState.billsList.loading = true;
        this.draftState.billsList.success = false;
        this.draftState.billsList.errorMessage = null;
        this.draftState.billsList.data = null;
    };
    invoiceState.prototype.fetchBillsListSuccess = function (data) {
        this.draftState.billsList.loading = false;
        this.draftState.billsList.success = true;
        this.draftState.billsList.errorMessage = null;
        this.draftState.billsList.data = data;
    };
    invoiceState.prototype.fetchBillsListFailure = function (error) {
        this.draftState.billsList.loading = false;
        this.draftState.billsList.success = false;
        this.draftState.billsList.errorMessage = error;
        this.draftState.billsList.data = null;
    };
    return invoiceState;
}(immer_reducer_1.ImmerReducer));
exports.invoiceState = invoiceState;
exports.invoiceActions = (0, immer_reducer_1.createActionCreators)(invoiceState);
exports.invoiceReducerFunction = (0, immer_reducer_1.createReducerFunction)(invoiceState, exports.initialState);
